// TODO: 패키지끼리 공유하는 유틸 함수를 공통 패키지로 빼는 작업이 필요합니다.

import { DOMAIN } from '@pairy/sheard/constants';

interface GetShareLinkProps {
  hashId: string;
  historyId: string;
  isBulk: boolean;
  domain?: string | null;
}

export const getFileShareLink = ({
  hashId,
  historyId,
  isBulk,
  domain,
}: GetShareLinkProps) => {
  const { hostname } = window.location;

  // CASE 1. localhost 환경에서 개발할 때
  if (hostname.includes(DOMAIN.VIEWER.local)) {
    const shareLink = isBulk
      ? `http://localhost:3002/share/bulk/file/${hashId}?sh=${historyId}`
      : `http://localhost:3002/share/file/${hashId}?sh=${historyId}`;

    return shareLink;
  }

  //CASE 2. dev.sclu.io인 경우 (=dev)
  if (hostname.includes(DOMAIN.VIEWER.dev)) {
    const shareLink = isBulk
      ? `https://${DOMAIN.VIEWER.dev}/share/bulk/file/${hashId}?sh=${historyId}`
      : `https://${DOMAIN.VIEWER.dev}/share/file/${hashId}?sh=${historyId}`;
    return shareLink;
  }

  // CASE 3. alpha.sclu.io인 경우 (= release test )

  if (hostname.includes(DOMAIN.VIEWER.release)) {
    const shareLink = isBulk
      ? `https://${DOMAIN.VIEWER.release}/share/bulk/file/${hashId}?sh=${historyId}`
      : `https://${DOMAIN.VIEWER.release}/share/file/${hashId}?sh=${historyId}`;
    return shareLink;
  }

  // CASE 4. sclu.io 인 경우 (=prod)

  if (hostname.includes(DOMAIN.VIEWER.main)) {
    const shareLink = isBulk
      ? `https://${DOMAIN.VIEWER.main}/share/bulk/file/${hashId}?sh=${historyId}`
      : `https://${DOMAIN.VIEWER.main}/share/file/${hashId}?sh=${historyId}`;

    return shareLink;
  }
  // CASE 5. 유저가 등록한 커스텀 도메인이 있는 경우

  if (domain && domain !== null) {
    const shareLink = isBulk
      ? `https://${domain}/share/bulk/file/${hashId}?sh=${historyId}`
      : `https://${domain}/share/file/${hashId}?sh=${historyId}`;

    return shareLink;
  }

  const shareLink = isBulk
    ? `https://${hostname}/share/bulk/file/${hashId}?sh=${historyId}`
    : `https://${hostname}/share/file/${hashId}?sh=${historyId}`;

  return shareLink;
};
